<template>
  <div class="font app-content isVisitor" >
    <section class="main-image">
      <div class="container text-white ">
        <h5>{{$t("message.db_top_comment1")}}</h5>
        <h1 class="mb-3">{{$t("message.db_top_pr")}}</h1>
        <p>{{$t("message.db_top_comment2")}}</p>
        <p>
          <b-button class="btn-red btn-lg-max" @click="showSignUpModal">{{$t("message.member_regist")}}</b-button>
        </p>
      </div>
    </section>
    <section class="footer-fixed-nav">
      <div class="container row mt-5 px-0">
        <div v-show="isMob()" class="col-6">
          <a href="/company.html"><img class="img-fluid mx-auto d-block" src="../assets/banner-partner-img.svg"></a>
        </div>
        <div v-show="!isMob()" class="col-4">
          <a href="/company.html"><img class="img-fluid mx-auto d-block" src="../assets/banner-partner-img-sp.svg"></a>
        </div>
        <div v-show="isMob()" class="col-6">
          <a href="/partner.html"><img class="img-fluid mx-auto d-block" src="../assets/banner-company-img.svg"></a>
        </div>
        <div v-show="!isMob()" class="col-4">
          <a href="/partner.html"><img class="img-fluid mx-auto d-block" src="../assets/banner-company-img-sp.svg"></a>
        </div>
      </div>
    </section>

    <div class="container" id="article1">
      <div class="row mt-5">
        <div class="col-12 col-md-7">
          <h2 class="title">{{$t("message.article1")}}</h2>
          <p>{{$t("message.article1_dec1")}}</p>
          <p>{{$t("message.article1_dec2")}}</p>
          <p>{{$t("message.article1_dec3")}}</p>
          <p>{{$t("message.article1_dec4")}}</p>
          <p>{{$t("message.article1_dec5")}}</p>
          <p>{{$t("message.article1_dec6")}}</p>
        </div>

        <div class="col-12 col-md-5">
          <img class="img-fluid mx-auto d-block mt-md-5 pt-md-5" src="../assets/top/PC_mobile/images/japan.png">
        </div>
      </div>
    </div>

    <div class="bg-gray" id="article7">
      <div class="container my-5 pt-5">
        <h2 class="title text-center">{{$t("message.article3")}}</h2>
        <div class="row mt-5">
          <div class="col-12 col-md-4 mb-4">
            <div class="card">
              <img class="card-img-top " src="../assets/top/PC_mobile/images/機能01_オンライン試験勉強.png" alt="オンライン試験勉強">
            </div>
            <div class="card stack-card mx-2 mx-lg-3 ">
              <div class="card-body">
                <h5 class="card-title text-center card-title-font">{{$t("message.article3_sub1")}}</h5>
                <p class="card-text">{{$t("message.article3_sub1_dec1")}}</p>
              </div>
            </div>
            <div class="col-12 text-right px-0">
              <img class="img-fluid card-corner mx-2 mx-lg-3" src="../assets/top/PC_mobile/icon/corner.png" alt="corner">
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <div class="card">
              <img class="card-img-top " src="../assets/top/PC_mobile/images/機能02_試験情報.png" alt="試験情報">
            </div>

            <div class="card stack-card mx-2 mx-lg-3">
              <div class="card-body mb-md-5 mb-lg-4">
                <h5 class="card-title text-center card-title-font pb-md-4 pb-lg-0">{{$t("message.article3_sub2")}}</h5>
                <p class="card-text mb-5">{{$t("message.article3_sub2_dec1")}}</p>
              </div>
            </div>
            <div class="col-12 text-right px-0">
              <img class="img-fluid card-corner mx-2 mx-lg-3" src="../assets/top/PC_mobile/icon/corner.png" alt="corner">
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <div class="card">
              <img class="card-img-top " src="../assets/top/PC_mobile/images/機能03_試験申し込み代行.png" alt="試験申し込み代行">
            </div>
            <div class="card stack-card mx-2 mx-lg-3">
              <div class="card-body">
                <h5 class="card-title text-center card-title-font">{{$t("message.article3_sub3")}}</h5>
                <p class="card-text">{{$t("message.article3_sub3_dec1")}}</p>
              </div>
            </div>
            <div class="col-12 text-right px-0">
              <img class="img-fluid card-corner mx-2 mx-lg-3" src="../assets/top/PC_mobile/icon/corner.png" alt="corner">
            </div>
          </div>
          <div class="col-10 col-md-10 mb-4 px-0 text-center mx-auto">
            <youtube :video-id="'yCFBuvHt7Lw'" :fitParent="true"/>
          </div>
        </div>
      </div>
    </div>
    <div class="container my-5 pt-5">
      <h2 class="title text-center">{{$t("message.article4")}}</h2>
      <div class="row text-center">
        <div class="col-12 col-md-4 mb-3 ">
          <img class="img-fluid" src="../assets/top/PC_mobile/images/試験合格後機能01,02.png" alt="corner">
          <h5 class="font-blue">{{$t("message.article4_sub1")}}</h5>
          <p class="px-1">{{$t("message.article4_sub1_dec1")}}</p>
        </div>

        <div class="col-12 col-md-4 mb-3 ">
          <img class="img-fluid" src="../assets/top/PC_mobile/images/試験合格後機能01,02.png" alt="corner">
          <h5 class="font-blue">{{$t("message.article4_sub2")}}</h5>
          <p class="px-1">{{$t("message.article4_sub2_dec1")}}</p>
        </div>

        <div class="col-12 col-md-4 mb-3 ">
          <img class="img-fluid" src="../assets/top/PC_mobile/images/試験合格後機能03.png" alt="corner">
          <h5 class="font-blue">{{$t("message.article4_sub3")}}</h5>
          <p class="px-1">{{$t("message.article4_sub3_dec1")}}</p>
        </div>

  <!--       <div class="col-12 col-md-3 mb-3 ">
          <img class="img-fluid" src="../assets/top/PC_mobile/images/試験合格後機能04.png" alt="corner">
          <h5 class="font-blue">{{$t("message.article4_sub4")}}</h5>
          <p class="px-1"> {{$t("message.article4_sub4_dec1")}}</p>
        </div> -->
      </div>
    </div>
    <div class="bg-gray">
      <div class="container my-5 pt-5">
        <div class="row mt-5">
          <div class="col-12 mb-4 text-center">
            <h2 class="title text-center">{{$t("message.sample_problem")}}</h2>
            <h4 class="mt-4  pt-3 mb-3">{{$t("message.exercises")}}</h4>
            <p> {{$t("message.let_exercises")}}</p>
          </div>
          <div v-for='(row, index) in sample' :key="row.id" class="col-12 mb-4" >
            <div >
              <b-card>
                <h4 class="ml-4 mt-4"> {{$t("message.industry_id_" + row.industry_id)}}</h4>
                <!-- <p class="ml-4 mt-4">{{row.title}}</p> -->
                <p class="ml-4 mt-4">{{translated_title[index]}}</p>
                <div v-if="row.photos != null" class="text-center">
                  <img :src="row.photos" style="width: 80%;"/>
                </div>
                <radio-choice  @setSample="setSample"  :choices="choices[index]" :id='row.id' v-if="row.question_type == 'radio'"></radio-choice>
                <checkbox-choice  @setSample="setSample" :choices="choices[index]" :id='row.id' v-if="row.question_type == 'checkbox'"> </checkbox-choice>
              </b-card>
              <two-choice  @setSample="setSample" :id='row.id' v-if="row.question_type == 'true_or_false'"></two-choice>
            </div>
            <div class="col-12 mb-4 " v-if="is_ans[row.id] != undefined ">
              <p class="text-center current bg-blue mb-0" v-if="is_ans[row.id] == row.answer ">{{$t("message.correct_answer")}}</p>
              <p class="text-center current bg-blue mb-0" v-else>{{$t("message.no_correct_answer")}}</p>
              <b-card class="px-3 px-md-5 py-3">
                <h3 class="answer-label" v-if="row.question_type == 'radio'"><span>{{$t("message.correct_answer_normal")}}:</span> {{ choices[index][Number(row.answer)].label }}</h3>
                <p class="mb-0" >{{ translated_commentary[index]}}</p>
              </b-card>
            </div>
          </div>
        </div>
      </div>

    </div>

    
    
    <div class="container" id="article8">
      <h2 class="title text-center">{{$t("message.article5")}}</h2>
      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub3")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub3_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func1.png">
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub4")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub4_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func2.png">
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub5")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub5_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func3.png">
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub6")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub6_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func4.png">
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub1")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub1_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func5.png">
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 mt-3 mt-lg-5 order-2 order-md-1">
          <img class="img-fluid pr-1 mb-1" src="../assets/top/PC_mobile/icon/right.png" >
          <h5 class="font-blue " style="display: inline">{{$t("message.article5_sub2")}}</h5>
          <p class="mt-3 mt-md-2">{{$t("message.article5_sub2_dec1")}}</p>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <img class="img-fluid ml-lg-5 pl-lg-5" src="../assets/top/PC/pc_func6.png">
        </div>
      </div>
    </div>



    <div class="bg-gray" id="how_to_use">
      <div class="container my-5 pt-5">
        <h2 class="title text-center">{{$t("message.how_to_use_this_service")}}</h2>
        <div class="row mt-5 pb-5">
          <div class="col-12 col-md-8 text-center mx-auto mb-4">
            <div class="card how_to_use">
              <h2><span>01</span>{{$t("message.selecting_a_browser")}}</h2>
              <p class="mb-0">{{$t("message.selecting_a_browser_dec")}}</p>
            </div>
          </div>

          <div class="col-12 col-md-8 text-center mx-auto mb-4">
            <div class="card how_to_use">
              <h2><span>02</span>{{$t("message.provisional_registration")}}</h2>
              <p class="mb-0">{{$t("message.provisional_registration_dec")}}</p>
            </div>
          </div>

          <div class="col-12 col-md-8 text-center mx-auto mb-4">
            <div class="card how_to_use">
              <h2><span>03</span>{{$t("message.full_registration")}}</h2>
              <p class="mb-0">{{$t("message.full_registration_dec")}}</p>
            </div>
          </div>

          <div class="col-10 col-md-10 mb-4 px-0 text-center mx-auto">
              <youtube :video-id="'iqbaRzoY3lQ'" :fitParent="true" />
          </div>


        </div>
      </div>

    </div>


    <div id="qa">
      <div class="container my-5 py-5">
        <h2 class="title text-center">Q&A</h2>
        <div class="row mt-5">
          <div class="col-12 col-md-8 col-lg-8 mx-auto pl-xl-5" >
            <ul class="px-0">
              <li class="news-li qa-li shortcut" v-for="qa in qa_list" :key="read_more_list[qa.id]" >
                
                <h5 class="qa_title"><b>Q: {{qa.title.rendered}}</b></h5>
                <span v-if="!read_more_list[qa.id]" class="answer">{{ ellipsis(qa.content.rendered).substr(0, 40) }}...<a @click="expand(qa)">{{$t("message.more_look")}}</a></span>
                <span v-if="read_more_list[qa.id]" class="answer" v-html="qa.content.rendered"></span>
              </li>
              <div class="hide" id='temp'></div>
            </ul>
          </div>
          <div class="col-12 col-md-8 col-lg-12 text-center" >
            <router-link :to="'./qa'">
              <b-button  class="next mt-4 py-2 px-5 ml-3" > {{$t("message.to_qa")}}</b-button>
            </router-link>
          </div>

        </div>
      </div>
    </div>



    <div class="bg-gray" id="fee">
      <div class="container my-5 py-5">
        <h2 class="title text-center">{{$t("message.article6")}}</h2>
        <div class="row mt-5">
          <div class="col-12 col-md-9 col-lg-9 mx-auto" >
            <div class="card ml-md-0 ml-lg-5 mr-lg-5 px-2 mb-5">
              <div class="card-body px-5 px-md-0 px-lg-3 px-xl-4">
                <h5 class="card-title article-title font-blue">{{$t("message.article6_sub1")}}</h5>
                <p class="card-text">{{$t("message.article6_sub1_dec1")}}</p>
                <div class="row">
                  <div class="col-6">
                    <h1 class="money">550</h1>
                    <h5 class="money-unit">{{$t("message.yen_per_month")}}</h5>
                  </div>
                  <div class="col-6 text-right m-auto">
                    <b-button class="btn-red btn-lg" @click="showSignUpModal">{{$t("message.member_regist")}}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-9 col-lg-9 mx-auto" >
            <div class="card mr-0 mr-lg-5 ml-lg-5 px-2 mb-5">
              <div class="card-body px-5 px-md-0 px-lg-3 px-xl-4">
                <h5 class="card-title article-title font-blue">{{$t("message.article6_sub2")}}</h5>
                <p class="card-text">{{$t("message.article6_sub2_dec1")}}</p>
                <p class="card-text">{{$t("message.article6_sub2_dec2")}}</p>
                <div class="row">
                  <div class="col-6">
                    <h1 class="money">2.2</h1>
                    <h5 class="money-unit">{{$t("message.ten_thousand_yen")}}</h5>
                  </div>
                  <div class="col-6 text-right m-auto">
                    <b-button class="btn-red btn-lg" @click="showSignUpModal">{{$t("message.member_regist")}}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container my-lg-5 pt-lg-5">
      <div class="row text-center">
        <div class="col-12 mb-5">
          <h2 class="title text-center">{{$t("message.article7")}}</h2>
          <p class="px-1 pt-3">{{$t("message.article7_dec1")}}</p>
          <div class="col-12 d-none d-md-block">
             <img class="img-fluid" src="../assets/top/PC/cashback_image.svg" alt="corner">
          </div>
          <div class="col-12 d-md-none">
            <img class="img-fluid" src="../assets/top/PC/cashback_image.svg" alt="corner">
          </div>
          
        </div>
      </div>
    </div>

    <div class="bg-gray">
      <div class="container mt-lg-5 py-5">
        <div class="row text-center">
          <div class="col-12">
            <h2 class="title text-center mb-4">{{$t("message.article8")}}</h2>
            <b-button class="btn-red btn-lg-max mt-2" @click="showSignUpModal">{{$t("message.member_regist")}}</b-button>
          </div>
        </div>
      </div>
    </div>

     <div class="container">
      <div class="row mt-5">
        <div class="col-12 col-md-7">
          <h2 class="title">{{$t("message.registration_support_organization")}}</h2>
          <p>{{$t("message.rso_dec1")}}</p>
          <p>{{$t("message.rso_dec2")}}</p>
          <p>{{$t("message.rso_dec3")}}</p>
          <p>{{$t("message.rso_dec4")}}</p>
          <p>{{$t("message.rso_dec5")}}</p>
          <p>{{$t("message.rso_dec6")}}</p>
          <p>{{$t("message.rso_dec7")}}</p>
          <p>{{$t("message.rso_dec8")}}</p>
        </div>

        <div class="col-12 col-md-5">
          <img class="img-fluid mx-auto d-block mt-md-5 pt-md-5" src="../assets/top/PC_mobile/images/rso.png">
        </div>
      </div>
    </div>   

    <div class="container my-5"  id="article3">
      <h2 class="title text-center">{{$t("message.article2")}}</h2>
      <div class="row mt-5">
        <div class="col-12 col-md-7 order-2 order-md-1 mt-5 mt-md-0">
          <h2 class="article-title">{{$t("message.article2_sub1")}}</h2>
          <p class="pr-md-5 mr-lg-5 mt-4">{{$t("message.article2_dec1")}} </p>
          <p><span class="space-after">{{$t("message.article2_dec2")}}</span><span class="space-after">{{$t("message.article2_dec3")}}</span>{{$t("message.article2_dec4")}}</p>
        </div>

        <div class="col-12 col-md-5 order-1 order-md-2">
          <img class="img-fluid mx-auto d-block" src="../assets/top/PC/代表メッセージ.png">
        </div>
      </div>
    </div>


    <signup-modal ref="signup"></signup-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex'; 

export default {
  components: {
    TwoChoice: () => import("@/components/User/Quiz/TwoChoice"),
    RadioChoice: () => import("@/components/User/Quiz/RadioChoice"),
    CheckboxChoice: () => import("@/components/User/Quiz/CheckboxChoice"),
    SignupModal: () => import("@/components/User/Session/SignupModal")
  },
  data () {
    return {
      sample: {},
      is_ans: {},
      qa_list: [],
      read_more_list: {},
      parPage: 5,
      choices: [],
      photos: [],
      lang_dict: { en: "en", ja: "ja", ban: "bn", bur: "bur", ch: "ch", hin: "hi", ind: "id", kh: "ku",lao: "lo", mon: "mn", ne: "ne", taga: "tl", thai: "th", vi: "vi"},

      translated_title: {},
      translated_commentary: {},
    }
  },
  methods: {
    isLong(value) {
      var text = this.ellipsis(value)
      return (text.length > 50)? true : false
    },
    isMob() {
      if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
        return false;
      } else {
        return true;
      }
    },
    expand(qa) {
      this.read_more_list[qa.id] = true
      this.qa_list.push({title: {rendered: ""}, content: {rendered: ""}})
      this.qa_list.pop()
    },
    ellipsis(value){
      document.querySelector("#temp").innerHTML = value;
      var textContent = document.querySelector("#temp").textContent;
      document.querySelector("#temp").innerHTML = "";

      return textContent;
    },
    setSample(ans, id){
      this.is_ans[id] = ans
      this.is_ans = Object.assign({}, this.is_ans)
    },
    showSignUpModal(){
      this.$refs.signup.showModal()
    },
    translate(q, i) {
      var lang = this.lang_dict[this.language] 
      if(lang != "ja") {
        axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: q, lang: lang})
          .then((res) => {
            this.translated_title[i] = res.data.text 
          }).catch(() => {})
      }else{
        this.translated_title[i] = q
      }
      this.translated_title = Object.assign({}, this.translated_title)
    },
    commentary_translate(q, i) {
      var lang = this.lang_dict[this.language] 
      if(lang != "ja") {
        axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: q, lang: lang})
          .then((res) => {
            this.translated_commentary[i] = res.data.text 
          }).catch(() => {})
      }else{
        this.translated_commentary[i] = q
      }
    },
    choices_translate(q) {
      var lang = this.lang_dict[this.language] 
      if(lang != "ja") {
        var choice = []
        JSON.parse(q).forEach((c, index) => {
          axios
          .post(process.env.VUE_APP_API + "/trial_examination/translate", {text: c.label, lang: lang})
          .then((res) => {
            choice.push({"label": res.data.text, "ia_answer": c.is_answer, value: index})
          }).catch(() => {})
          this.choices.push(choice)
        })
      }else{
        var choice_ja = []
        JSON.parse(q).forEach((c, index) => {
          c["value"] = index
          choice_ja.push(c) 
        })
        this.choices.push(choice_ja)
      }
    },
  },
  computed: {
      ...mapState({
        language: state => state.language
      }),
  },
  async mounted() {
    console.log("-----------")
    console.log(this.isMob())
    var url = ""
    if(this.lang_dict[this.language] == "ja"){
      url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1"
    }else{
      url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[this.language]
    }
    await axios
    .get(url)
    .then(response => {
      this.qa_list = response.data
      for(var qa in this.qa_list) {
        this.read_more_list[this.qa_list[qa].id] = !this.isLong(this.qa_list[qa].content.rendered)
      }
    }).catch(error => {
      console.log('this is error', error)
    })  
    axios
    .get(process.env.VUE_APP_API + "/sample")
    .then(response => {
      this.sample_qs = response.data  
      this.sample = response.data
      this.photos = (this.sample.photos || "" ).split(",")

      this.sample_qs.forEach((item, i) => {
        this.translate(item.title, i)
        this.commentary_translate(item.commentary, i) 
        if(item.question_type == 'radio') {
          this.choices_translate(item.content)
        }
        this.is_ans[item.id] = undefined
      })
    }).catch(() => {
    })
    this.$store.commit('setLoading', false)
  },
  watch:{
    async language(val){
      var url = ""
      if(this.lang_dict[this.language] == "ja"){
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1"
      }else{
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[val]
      }
      axios
      .get(url)
      .then(response => {
        this.qa_list = response.data
        this.read_more_list = {}
        for(var qa in this.qa_list) {
          this.read_more_list[this.qa_list[qa].id] = !this.isLong(this.qa_list[qa].content.rendered)
        }
      }).catch(error => {
        console.log('this is error', error)
      })
      this.choices = []
      await this.sample_qs.forEach((item, i) => {
        console.log(item.question_type)
        this.translate(item.title, i)
        this.commentary_translate(item.commentary, i) 
        if(item.question_type == 'radio') {
          this.choices_translate(item.content)
        }
        this.is_ans[item.id] = undefined
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"> 
.youtube iframe {
  width: 100% !important;
}

.main-image{ 
  margin-bottom: 0;
  background-image: url("../assets/top/PC/key_visual.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 10rem;
  padding-bottom: 6rem;
}
.black-fillter{
  background-color:  rgba(0,0,0,0.6);
  
}
.space-after{
  margin-right : 1rem;
}
.stack-card{
  margin-top: -2rem;
}

.card-title-font{
  color: #000054;
}

.card-corner{
  margin-top: -3rem;
  z-index: 1;
  position: relative;
}

.money{
  font-weight: bold;
  font-size: 60px;
  line-height: 89px;
  display: inline
}
.money-unit{
  font-weight: bold;
  font-size: 30px;
  line-height: 44px;
  display: inline
}

.bg-blue{
  background:#000054;
  color: #FFFFFF;
  height: 70px;
}

.current{
  font-size: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}

@media (max-width: 576px) {
   .main-image{ 
    background-image: url("../assets/top/mobile/images/key_visual.png");
    padding-top: 3rem;
    padding-bottom: 2rem;
  }
}

::v-deep .answer  {
  p {
    margin-bottom: 0px;
    white-space: normal;
  }
  font-size: 16px; 
}
span.answer {
  margin-bottom: 0px;
  white-space: normal;
}

.input_bg{
  background-color: #F5F5F8;
  border-radius: 26px;
}

.news-li{
  list-style: none;
}

.qa_title {
  margin: 10px 0px;
  margin-bottom: 10px;
  padding: 10px 0px;
  font-size: 18px;
  white-space: normal;
}
.qa-li {
  padding: 10px 0px;
  padding-bottom: 25px; 
  border-bottom: 1px solid #d8dadc
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}

.how_to_use {
  text-align: left;
  padding: 25px 45px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    span {
      color: #F29147;
      padding: 0px 5px;
    }
  }
  p {
    margin-left: 2rem !important;
  }
}
.answer-label {
  font-size: 22px;
  text-align: center;
  span {
    font-size: 20px;
  }
}

.footer-fixed-nav {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    z-index: 1000;

    .container {
      margin: auto;
    }
}



</style>
